














































































import { Vue, Component, Prop } from "vue-property-decorator";
import { db, VIPCertificate, VIPCapabilityCertificate, VIPIp } from "@/loader";
import dayjs, { Dayjs } from "dayjs";
import CertificateListItem from "./CertificateListItem.vue";

@Component({
	components: {
		CertificateListItem,
	},
})
export default class CertificatesList extends Vue {
	@Prop({ type: Array, default: () => [] })
	public items!: (VIPCertificate | VIPCapabilityCertificate)[];

	@Prop({ type: Dayjs, default: null })
	public date!: Dayjs | null;

	@Prop({ type: Boolean, default: false })
	public canEdit!: boolean;

	@Prop({ type: Boolean, default: false })
	public canAdd!: boolean;

	@Prop({ type: Object, default: null })
	public ip!: VIPIp | null;

	public certificate: VIPCertificate | null = null;

	public get compareDate(): Dayjs {
		return !this.date ? dayjs() : this.date;
	}

	public get certificates() {
		return this.items.map(item => item instanceof VIPCertificate ? item : item.certificate);
	}

	public get possible_certificates() {
		return db.certificates.list.filter(c => c.ips.some(ips => ips.ip === this.ip) && c.isSigned && !this.certificates.includes(c));
	}

	public get_pk(item: VIPCertificate | VIPCapabilityCertificate): Number {
		return item instanceof VIPCapabilityCertificate ? item.fk_certificate : item.id;
	}
}
